<div class="app-stack">
  <section class="app-page-card app-stack">
    <div class="app-header-row">
      <div>
        <h2>Valuations</h2>
        <p class="app-muted">Start a new valuation or resume one already in progress.</p>
      </div>
      <calcite-button kind="brand" appearance="solid" scale="m" icon-start="plus" (click)="startNewValuation()">
        New Valuation
      </calcite-button>
    </div>

    @if (error()) {
      <p class="app-error" role="alert">{{ error() }}</p>
    }
  </section>

  <section class="app-panel app-stack">
    <h3>My Valuations</h3>

    @if (loading()) {
      <p class="app-muted" aria-live="polite">Loading valuations…</p>
    } @else if (myValuations().length) {
      <calcite-table caption="My valuations" bordered>
        <calcite-table-row slot="table-header">
          <calcite-table-header heading="Address"></calcite-table-header>
          <calcite-table-header heading="Appeal Year"></calcite-table-header>
          <calcite-table-header heading="Status"></calcite-table-header>
          <calcite-table-header heading="Updated"></calcite-table-header>
        </calcite-table-row>
        @for (valuation of myValuations(); track valuation.session_id) {
          <calcite-table-row class="valuation-row" (click)="openValuation(valuation.session_id)">
            <calcite-table-cell>{{ valuation.property_address }}</calcite-table-cell>
            <calcite-table-cell>{{ valuation.appeal_year }}</calcite-table-cell>
            <calcite-table-cell>{{ valuation.status }}</calcite-table-cell>
            <calcite-table-cell>{{ valuation.updated_at | date: 'medium' }}</calcite-table-cell>
          </calcite-table-row>
        }
      </calcite-table>
    } @else {
      <p class="app-muted">You haven't started any valuations yet.</p>
    }
  </section>

  <section class="app-panel app-stack">
    <h3>Other Valuations</h3>

    @if (loading()) {
      <p class="app-muted" aria-live="polite">Loading valuations…</p>
    } @else if (otherValuations().length) {
      <calcite-table caption="Other valuations" bordered>
        <calcite-table-row slot="table-header">
          <calcite-table-header heading="Address"></calcite-table-header>
          <calcite-table-header heading="Appeal Year"></calcite-table-header>
          <calcite-table-header heading="Status"></calcite-table-header>
          <calcite-table-header heading="Updated"></calcite-table-header>
          <calcite-table-header heading="Created by"></calcite-table-header>
        </calcite-table-row>
        @for (valuation of otherValuations(); track valuation.session_id) {
          <calcite-table-row class="valuation-row" (click)="openValuation(valuation.session_id)">
            <calcite-table-cell>{{ valuation.property_address }}</calcite-table-cell>
            <calcite-table-cell>{{ valuation.appeal_year }}</calcite-table-cell>
            <calcite-table-cell>{{ valuation.status }}</calcite-table-cell>
            <calcite-table-cell>{{ valuation.updated_at | date: 'medium' }}</calcite-table-cell>
            <calcite-table-cell>{{ valuation.created_by || '—' }}</calcite-table-cell>
          </calcite-table-row>
        }
      </calcite-table>
    } @else {
      <p class="app-muted">No other valuations yet.</p>
    }
  </section>
</div>
